'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function ($http) {
  'ngInject';

  this.uploadFormToUrl = function (form, files, uploadUrl) {
    //TODO ie9 support
    var fd = [];
    //    if ( angular.isUndefined($window.FormData) ) {
    //      angular.forEach(form, function (value, key) {
    //        fd.push(key, value);
    //      });
    //      for(let i=0; i<files.length; i++){
    //        fd.push('file'+i, files[i]);
    //      }
    //    } else {
    fd = new FormData();
    angular.forEach(form, function (value, key) {
      fd.append(key, value);
    });
    // Changed when switching to Spring MVC from servlet
    // http://stackoverflow.com/questions/22482170/how-do-i-send-an-array-of-files-using-xhr2-and-formdata-java-spring
    for (var i = 0; i < files.length; i++) {
      //      fd.append('file'+i, files[i]);
      fd.append('files', files[i]);
    }
    //    }
    //Usually we don't use undefined, but it is necessary to put it in the header
    var myUndefined = void 0;
    return $http.post(uploadUrl, fd, {
      transformRequest: angular.identity,
      headers: {
        'Content-Type': myUndefined
      }
    });
  };
};


// WEBPACK FOOTER //
// ./src/credit-request/shared/services/form-upload.js